import { Checkbox } from '@mui/material'
import React from 'react'
import { Menu } from 'react-feather'
import InputTextField from 'src/components/common/form-elements/InputTextField'
import { SelectedTrustBadgeType } from 'src/lib/types/customizeUI'
import { useLocale } from 'src/lib/hooks/useLocal'
import { useCustomizeUIContext } from 'src/lib/contexts/CustomizeUIProvider'
import { errorToast } from 'src/lib/utils/toasters'

interface TrustBadgeProps {
  badge: SelectedTrustBadgeType
  index: number
  isEnabled: boolean
  isInputDisabled?: boolean
}

const TrustBadge: React.FC<TrustBadgeProps> = ({ badge, index, isEnabled, isInputDisabled = false }) => {
  const { t } = useLocale()
  const trustBadgesConfig = useCustomizeUIContext(context => context.state.trustBadgesConfig)
  const setTrustBadgesConfig = useCustomizeUIContext(context => context.actions.setTrustBadgesConfigData)

  const handleChangeText = (value: string) => {
    const modifiedTrustBadges = [...(trustBadgesConfig?.badges ?? [])]
    const trustBadgeToModify = { ...badge }
    const badgeIndex = trustBadgesConfig?.badges?.findIndex(
      (selectedBadge: SelectedTrustBadgeType) => selectedBadge?.label === badge?.label
    )
    trustBadgeToModify.text = value
    modifiedTrustBadges[badgeIndex] = trustBadgeToModify
    setTrustBadgesConfig({ ...trustBadgesConfig, badges: [...modifiedTrustBadges] })
  }

  const handleBadgeSelect = () => {
    const activeBadges = trustBadgesConfig?.badges.filter((badge: SelectedTrustBadgeType) => badge?.isActive) ?? []
    const modifiedTrustBadges = [...(trustBadgesConfig?.badges ?? [])]
    const trustBadgeToModify = {
      ...trustBadgesConfig?.badges?.find(
        (selectedBadge: SelectedTrustBadgeType) => selectedBadge.label === badge?.label
      )
    }
    const updatedBadges = modifiedTrustBadges.map(obj => {
      if (obj.label === trustBadgeToModify.label) {
        if (isEnabled) {
          return { ...obj, isActive: false, text: '' }
        } else {
          if (activeBadges?.length < 4) {
            return { ...obj, text: '', isActive: true, weight: 0 }
          }
          errorToast(t('trust_badge_error'))
        }
      }
      return { ...obj }
    })

    const showBadges = updatedBadges?.some((badge: SelectedTrustBadgeType) => badge?.isActive)

    setTrustBadgesConfig({ showBadges: showBadges, badges: updatedBadges })
  }

  return (
    <>
      <li
        key={index}
        className={`${index === 0 ? 'border-none' : 'border-t'} ${
          isEnabled ? 'bg-[#fff]' : 'bg-[#FAFAFA]'
        } p-3 flex items-center justify-between gap-3`}
      >
        {isEnabled && <Menu size='16' className='stroke-[2.5px] text-[#949494]' />}
        <div className='flex items-center justify-center border rounded-lg h-9 w-9'>
          <img className='w-6 h-6' src={badge?.imgPath} alt='' />
        </div>
        {isEnabled ? (
          <div className='box-border h-9 grow'>
            <InputTextField
              isDisabled={isInputDisabled}
              inputProps={{ style: { fontFamily: 'monospace', fontWeight: '400', height: '100%' } }}
              textFieldId={`trust-badge-${badge?.label}`}
              inputValue={badge?.text}
              handleChange={(event: any) => handleChangeText(event?.target?.value)}
              inputPlaceholder={t('trust_badge_placeholder')}
            />
          </div>
        ) : (
          <div className='text-sm text-[#949494] grow h-9 flex items-center' onClick={handleBadgeSelect}>
            {t('click_to_add')}
          </div>
        )}
        <Checkbox
          disabled={isInputDisabled}
          checked={isEnabled}
          sx={{
            margin: 0,
            padding: 0,
            marginLeft: 'auto',
            height: '13.5px',
            width: '13.5px',
            color: '#4D4D4D',
            '&.Mui-checked': {
              color: '#4D4D4D'
            }
          }}
          onChange={handleBadgeSelect}
        />
      </li>
    </>
  )
}

export default TrustBadge
